export default "__VITE_ASSET__33f7a492__"